import request from "@/utils/request";

export default function transfer(id, userType, userId) {
    return request({
        url: `/news/agency/transfer/${id}/${userType}/${userId}`,
        method: 'get',
    })
}
